import React from 'react';
import { publisherData } from '../data/mockData';
import { MapPin, Calendar } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const AboutSection = () => {
  return (
    <section id="sobre-nosotros" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              Sobre Nosotros
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-amber-800 mx-auto mb-8"></div>
          </div>

          {/* Description Card */}
          <Card className="bg-gradient-to-br from-gray-50 to-white border-gray-200 shadow-xl mb-8">
            <CardContent className="p-8 md:p-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-8">
                {publisherData.description}
              </p>
              
              {/* Details */}
              <div className="flex flex-col md:flex-row md:items-center md:justify-center gap-6 pt-6 border-t border-gray-200">
                <div className="flex items-center space-x-3 text-gray-600">
                  <MapPin className="text-amber-600" size={24} />
                  <span className="text-lg">{publisherData.location}</span>
                </div>
                <div className="hidden md:block w-px h-8 bg-gray-300"></div>
                <div className="flex items-center space-x-3 text-gray-600">
                  <Calendar className="text-amber-600" size={24} />
                  <span className="text-lg">Fundada en {publisherData.year}</span>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Mission Statement */}
          <div className="text-center bg-gradient-to-r from-amber-600 to-amber-800 text-white p-8 rounded-lg shadow-lg">
            <p className="text-2xl font-serif italic">
              {publisherData.tagline}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};